import { NECST_DAC, NECST_DCC } from "./necst-ratenkredit";

export const PRODUCTS = [NECST_DCC, NECST_DAC];
